import ErrorInner from "../components/ErrorInner";
import Preloader from "../helper/Preloader";
import Animation from "../helper/Animation";
import HeaderOne from "../components/HeaderOne";
import { useLoader } from "../context/LoaderContext";
import { FetchAllApi } from "../components/FetchAllApi";
import { useAllDataContext } from "../context/AllDataContext";
import { useEffect } from "react";
import { fetchCompanyDetails } from "../api/CompanyDetailsApi";
import FooterThree from "../components/FooterThree";
import { useCompanyDetailsContext } from "../context/CompanyDetailsContext";

const ErrorPage = () => {
  const { setLoading } = useLoader();
  const { companyDetailsData, setCompanyDetailsData } =
    useCompanyDetailsContext();

  const { setAllData } = useAllDataContext();

  FetchAllApi({ companyDetailsData, setAllData, setLoading });
  useEffect(() => {
    if (companyDetailsData.length === 0) {
      Promise.all([fetchCompanyDetails()])
        .then(([companyDetailsData]) => {
          setCompanyDetailsData(companyDetailsData);
        })
        .catch(() => {
          console.error("Server Error");
        });
    }
  }, [companyDetailsData.length, setCompanyDetailsData]);

  return (
    <>
      <Preloader />
      <Animation />
      <HeaderOne />
      <ErrorInner />
      <FooterThree />
    </>
  );
};

export default ErrorPage;
